import { Link } from 'react-router'
import { Reveal, Section, SectionHeading } from '@/components/primitives'

const DOORS = [
  {
    label: 'Insurance & regulated sales',
    promise: 'Depth where compliance and volume collide.',
    to: '/solutions#insurance',
  },
  {
    label: 'Contact centers',
    promise: 'Floor, routing, and conversations as one system.',
    to: '/solutions#contact-centers',
  },
  {
    label: 'Growth & acquisition',
    promise: 'Source to outcome without losing the thread.',
    to: '/solutions#sales-acquisition',
  },
  {
    label: 'Field & distributed sales',
    promise: 'Same model in the office and on the road.',
    to: '/solutions#in-person-sales',
  },
]

export function WhoFor() {
  return (
    <Section labelledBy="who-heading" className="bg-base-900/40">
      <Reveal>
        <SectionHeading
          id="who-heading"
          title="Built for operations that can’t afford dropped work."
          copy="Same platform. Your sources, rules, documents, and floor, configured to how you actually run."
        />
      </Reveal>

      <Reveal delay={80}>
        <ul className="mt-12 grid gap-px overflow-hidden rounded-sm border border-base-line bg-base-line sm:grid-cols-2 lg:grid-cols-4">
          {DOORS.map((door) => (
            <li key={door.label} className="bg-base-850">
              <Link
                to={door.to}
                className="flex h-full flex-col p-6 text-center transition-colors duration-state hover:bg-base-800"
              >
                <p className="text-base font-extrabold tracking-tight text-ink">{door.label}</p>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-ink-mute">{door.promise}</p>
                <span className="mt-5 font-mono text-[11px] font-medium uppercase tracking-[0.14em] text-signal">
                  Explore →
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </Reveal>
    </Section>
  )
}
